export default __webpack_public_path__ + "static/media/im.8548e4df.jpg";